import {
  AddressPredictionsQuery,
  AddressPredictionsQueryVariables,
  UseAddressSuggestionProps,
} from "@ctypes";
import { ADDRESS_PREDICTIONS } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useAddressSuggestion = ({ input, skip = false }: UseAddressSuggestionProps) => {
  const { data: queryData, ...rest } = useQuery<
    AddressPredictionsQuery,
    AddressPredictionsQueryVariables
  >(ADDRESS_PREDICTIONS, {
    variables: {
      input,
    },
    skip: input.length === 0 || skip,
  });

  const data = queryData?.addressPredictions?.predictions ?? [];

  return { data, ...rest };
};
